<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">CRM管理</Breadcrumb-item>
        <Breadcrumb-item>公共资源</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div style="margin-top: 10px">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
            <Col span="8">
            <Form-item :label-width="85" label="注册日期:">
              <Col span="11">
              <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                          @on-change="regTimeStartChange"
                          :value="queryParam.regStartTimeDate" style="width: 100%"></Date-picker>
              </Col>
              <Col span="1" style="text-align: center">
              -</Col>
              <Col span="11">
              <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                           @on-change="regTimeEndChange"
                           :value="queryParam.regEndTimeDate" style="width: 100%"></Date-picker>
              </Col>
            </Form-item>
            </Col>
            <Col span="8">
            <Form-item :label-width="85" label="最后联系:">
              <Col span="11">
              <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                           @on-change="linkTimeStartChange"
                           :value="queryParam.linkStartTimeDate" style="width: 100%"></Date-picker>
              </Col>
              <Col span="1" style="text-align: center">
              -</Col>
              <Col span="11">
              <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                           @on-change="linkTimeEndChange"
                           :value="queryParam.linkEndTimeDate" style="width: 100%"></Date-picker>
              </Col>
            </Form-item>
            </Col>
            <Col span="8">
            <Form-item :label-width="85" label="最近登录:">
              <Col span="11">
              <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                           @on-change="loginTimeStartChange"
                           :value="queryParam.lastLoginTimeStart" style="width: 100%"></Date-picker>
              </Col>
              <Col span="1" style="text-align: center">
              -</Col>
              <Col span="11">
              <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                           @on-change="loginTimeEndChange"
                           :value="queryParam.lastLoginTimeEnd" style="width: 100%"></Date-picker>
              </Col>
            </Form-item>
            </Col>
            <Col span="6">
            <FormItem label="接通状态：">
              <Select v-model="queryParam.connectionStatus" placeholder="不论">
                <Option value="1">未拨打</Option>
                <Option value="2">拨打未接</Option>
                <Option value="3">拨打接通</Option>
                <Option value="-1">不论</Option>
              </Select>
            </FormItem>
            </Col>
            <Col span="6">
            <FormItem label="意向等级：">
              <Select v-model="queryParam.intentLevel" placeholder="不论">
                <Option value="1">高意向</Option>
                <Option value="2">意向一般</Option>
                <Option value="3">待跟进</Option>
                <Option value="4">无效资源</Option>
                <Option value="-1">不论</Option>
              </Select>
            </FormItem>
            </Col>
            <Col span="6">
            <Form-item label="学生:" :label-width="80">
              <Input placeholder="ID/手机号/姓名" name="searchKeyword"
                     v-model="queryParam.searchKeyword"></Input>
            </Form-item>
            </Col>
            <Col span="6">
            <FormItem label="学员状态：" :label-width="95">
              <Select v-model="queryParam.stdStatus"  placeholder="不论">
                <Option value="1">新注册</Option>
                <Option value="3">已预约</Option>
                <Option value="4">已试听</Option>
                <Option value="5">付款未绑定</Option>
                <Option value="6">已绑定</Option>
                <Option value="7">已开课</Option>
                <Option value="8">已完课</Option>
                <Option value="9">退费</Option>
                <Option value="-1">不论</Option>
              </Select>
            </FormItem>
            </Col>
          <Col span="6">
            <Form-item label="渠道：">
              <channel-select v-model="queryParam.regType"></channel-select>
            </Form-item>
          </Col>
            <Col span="6">
              <Button type="primary" @click="search()">搜索</Button>
            </Col>
          </Row>
      </Form>
      <Col>
     <!-- <Button type="primary" @click="exportDaiyTransOut" :onloading="exportLoading">导出</Button>-->
      </Col>

    </div>
    <div class="move-btn">
      <Button type="primary" @click="onAssignAdviser">批量移至私库</Button>
    </div>
    <List style="margin-top: 10px" :tableColumns="assignTitle" listUrl="/userinfo/treasuryResource"
          :params="queryParam" :onLoading="onLoading" :reload="reload" @on-selection-change="selectionChange"></List>
    <!--<UserInfoModal :value="editUser" @on-close="closeModal" :uid="uid" :successCallback="search"></UserInfoModal>-->
    <AssignAdviserTreModal :successCallback="search" :userList="selectionUser"
                        v-model="showAssignAdviserModal"></AssignAdviserTreModal>
  </div>
</template>
<script>
  import UserInfoModal from './UserInfoModal.vue'
  import AssignAdviserTreModal from './AssignAdviserTreModal.vue'
  export default {
    components: {
      UserInfoModal, AssignAdviserTreModal,
    },
    data () {
      let $constant = this.$constant
      return {
        exportLoading: false,
        showAssignAdviserModal: false,
        selectionUser: [],
        searchLoading: false,
        editUser: false,
        reload: 0,
        url: '/userinfo/treasuryResource',
        uid: null,
        queryParam: {
          resourceStatus: 2,
          intentLevel: '',
          stdStatus: '',
          adviserId: '',
          connectionStatus: '',
          regStartTimeDate: '',
          regEndTimeDate: '',
          linkStartTimeDate: '',
          startTime: '',
          lastLoginTimeStart: '',
          lastLoginTimeEnd: '',
          linkEndTimeDate: '',
          studentTag: null,
          bookTestId: '',
          searchKeyword: '',
          studyAdviserId: '',
          // 查询区分字段,1查询体验名单;2查询体验学生
         // cmd: 1,
          studentLessonState: '',
        },
        studyAdvisers: [],
        assignTitle: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '学生ID/姓名',
            width: 150,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.uid + '-' + row.nickName)
            }
          },
          {
            title: '手机号',
            width: 150,
            align: 'center',
            render: (h, params) => {
              if (params.row.mobile.startsWith('n')) {
                return h('span', '')
              }
              return h('Poptip', {
                props: {
                  trigger: 'hover'
                }
              }, [
                h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) +
                '****' + params.row.mobile.substring(7) : params.row.mobile),
                // 当前行展示的数据
                h('div', {slot: 'content'}, params.row.mobile)
              ])
            }
          },
          {
            title: '打电话',
            width: 150,
            render: (h, params) => {
              let row = params.row
              return h('div', [
                h('button', {attrs: {class: 'telephone2'}, on: {click: () => this.dialTel(row.id, row.mobile)}})
              ])
            }
          },
          // {
          //   title: '城市',
          //   key: 'allCity',
          //   width: 120,
          // },
          {
            title: '注册渠道',
            width: 120,
            align: 'center',
            key: 'regType'
            // render: (h, params) => {
            //   let regType = params.row.regType
            //   let canalEnum = $constant.getEnum($constant.studentCanal, regType)
            //   return h('div', canalEnum && canalEnum.text)
            // }
          },
          {
            title: '推荐人',
            align: 'center',
            width: 110,
            key: 'auName',
          },
          // {
          //   title: '创建人',
          //   width: 110,
          //   key: 'creatorName',
          // },
          {
            title: '最近登录',
            align: 'center',
            width: 100,
            key: 'lastLoginTime',
          },
          {
            title: '注册时间',
            align: 'center',
            width: 170,
            key: 'gmtCreate',
          },
          {
            title: '接通状态',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let status = params.row.connectionStatus
              let typeEnum = $constant.getEnum($constant.connectionStatus, status)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '客户意向',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let status = params.row.intentLevel
              let typeEnum = $constant.getEnum($constant.intentLevel, status)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '名单标签',
            align: 'center',
            width: 120,
            render: (h, params) => {
              let assignNum = params.row.assignNum
              let assignNumEnum = $constant.getEnum($constant.assignNumEnum, assignNum)
              return h('div', assignNumEnum && assignNumEnum.text)
            }
          },
          {
            title: '试听课',
            align: 'center',
            key: 'openTime',
            width: 100,
          },
          {
            title: '最后联系时间',
            align: 'center',
            width: 150,
            key: 'lastPhoneTime',
          },
          {
            title: '学员状态',
            align: 'center',
            width: 110,
            render: (h, params) => {
              let status = params.row.stdStatus
              let typeEnum = $constant.getEnum($constant.stdStatus, status)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: 'Follow Up',
            width: 250,
            align: 'center',
            key: 'followUpContent'
          },
          {
            title: '操作',
            width: 100,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      this.onPass(params.row)
                    }
                  }
                }, '移至私库')
              ])
            }
          },
        ],
      }
    },
    methods: {
      search () {
        this.selectionUser = []
        this.reload = new Date().getTime()
      },
      // 分配课程顾问
      onAssignAdviser () {
        if (this.selectionUser.length <= 0) {
          this.$Message.warning('请选择需分配课程顾问的学生！')
          return
        }
        this.showAssignAdviserModal = true
      },
      selectionChange (selection) {
        this.selectionUser = selection
      },
      onPass (row) {
        if (this.$store.get('adviserInfo')) {
          this.adviserGroupSelectDisable = this.$store.get('adviserInfo').teamType !== 0
          this.adviserId = this.$store.get('adviserInfo').adviserId
        }
        let self = this
        self.$Modal.confirm({
          title: '温馨提示',
          content: '是否<span style="color: red">移至</span>此资源?',
          width: 300,
          okText: '确认',
          onOk: () => {
            self.$http.post('/userList/crmTreasuryUpdate', {stuId: row.uid, thcId: this.adviserId}).then(function (res) {
              if (res) {
                self.search()
              }
            })
          }
        })
      },
      dial (mobile) {
        if (!mobile) {
          this.$Message.warning('无效手机号码')
          return
        }
        this.$http.get('/moor/call?callno=' + mobile)
      },
      edit (uid) {
        this.uid = uid
        this.editUser = true
      },
      closeModal (val) {
        this.editUser = val
        this.uid = null
      },
      exportDaiyTransOut () {
        this.exportLoading = true
        this.$http.get('/userinfo/exportUserInfo', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
          if (response.data) {
            let blob = new Blob([response.data], {type: 'text/csv'})
            let link = document.createElement('a')
            link.target = '_blank'
            link.href = window.URL.createObjectURL(blob)
            link.download = '公共资源名单.csv'
            link.click()
            this.exportLoading = false
          } else {
            this.$Message.error(response.msg)
          }
        }).catch((e) => {
          this.exportLoading = false
        })
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
    //  showMyStudent () {
     //   this.title = this.trailLessonTitle
      //  this.queryParam.cmd = 2
      //  this.search()
     // },
     // showNewAssign () {
    //    this.title = this.assignTitle
     //   this.queryParam.cmd = 1
     //   this.search()
    //  },
      regTimeStartChange (val) {
        this.queryParam.regStartTimeDate = val
      },
      regTimeEndChange (val) {
        this.queryParam.regEndTimeDate = val
      },
      lessonStartTimeChange (val) {
        this.queryParam.lessonStartTimeDate = val
      },
      lessonEndTimeChange (val) {
        this.queryParam.lessonEndTimeDate = val
      },
      linkTimeStartChange (val) {
        this.queryParam.linkStartTimeDate = val
      },
      linkTimeEndChange (val) {
        this.queryParam.linkEndTimeDate = val
      },
      loginTimeStartChange (val) {
        this.queryParam.lastLoginTimeStart = val
      },
      loginTimeEndChange (val) {
        this.queryParam.lastLoginTimeEnd = val
      },
    },
    created: function () {
      let startTime = this.queryParam.startTime
      if (startTime !== '') {
        this.queryParam.regStartTimeDate = this.$moment.unix(startTime).toDate()
      }
      if (startTime === '') {
        let momentDate = this.$moment().add(-24, 'M')
        momentDate.millisecond(0)
        momentDate.second(0)
        momentDate.minute(0)
        momentDate.hour(0)
        this.queryParam.regStartTimeDate = momentDate.toDate()
        this.queryParam.startTime = momentDate.format('X')
      }
    },
    mounted: function () {
      let self = this
      self.$http.get('/adminUser/listByCondition?adminGroupId=' + 4).then(function (res) {
        self.studyAdvisers = res.data
      })
      this.cmd = 1
      this.title = this.assignTitle
      this.search()
    },
    dialTel (uid, mobile) {
      // 待增加,呼出电话功能
      if (!uid) {
        this.$Message.warning('学生ID不能为空')
        return
      }
      if (!mobile) {
        this.$Message.warning('无效手机号码')
        return
      }
      this.dialLoading = true
      let self = this
      this.$http.get('/moor/call?callNo=' + mobile).then(function (res) {
        if (res.data > 0) {
          self.$Message.success('呼出成功!')
          self.dialLoading = false
        }
      })
    },
  }
</script>

<style scoped>
  .move-btn {
    display: flex;
    justify-content: end;
    margin-top: 24px;
  }
</style>



// WEBPACK FOOTER //
// TreasuryResource.vue?3112667e